"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var theme_pricing_system_1 = require("../../../../theming/theme.pricing-system");

var StaticText = function (_super) {
  __extends(StaticText, _super);

  function StaticText() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  StaticText.prototype.render = function () {
    return react_1.default.createElement(react_native_1.Text, {
      style: [theme_pricing_system_1.pricingStyles.staticTextTextStyle, this.props.textStyle]
    }, this.props.text);
  };

  return StaticText;
}(react_1.default.Component);

exports.StaticText = StaticText;